
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  template: `
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-4">
        <div class="flex flex-row justify-center">
          <div
            class="spinner"
            [style.width.px]="spinnerDiameter"
          [style.height.px]="spinnerDiameter"></div>
        </div>
        @if (showText) {
          <div class="flex flex-row justify-center">
            <span class="text-2xl font-bold">불러오는 중...</span>
          </div>
        }
      </div>
    </div>
    `,
  styles: [
    `
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      .spinner {
        border: 4px solid #f3f3f3; /* Light grey */
        border-top: 4px solid #3498db; /* Blue */
        border-radius: 50%;
        width: 2.5rem; /* Spinner size */
        height: 2.5rem; /* Spinner size */
        animation: spin 2s linear infinite;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerComponent {
  @Input() showText = true;
  @Input() spinnerDiameter = 100;
}
